<template>
  <div class="sa-card sa-card-border sa-card-noshadow">
    <avtar
      :editBoolean="editBoolean"
      @editFlag="pflag = $event"
      @imgEvent="imgUrl = $event"
    />
    <ValidationObserver ref="form" v-slot="{ handleSubmit }">
      <div class="sa-tit-heading sa-h-sm-up">Personal Information</div>
      <form @submit.prevent>
        <div class="sa-row" v-if="pflag">
          <div class="sa-col-xs12 sa-col-sm6 sa-col-md6 sa-col-lg4">
            <div class="sa-form-group">
              <ValidationProvider
                name="title"
                rules="required"
                v-slot="{ errors }"
                tag="div"
                class="sa-form-group"
              >
                <label>
                  Title
                  <span class="sa-red-text">*</span>
                </label>
                <v-select
                  :options="nameTitles"
                  v-model="personalInfoReq.personal.title_id"
                  label="name"
                  :reduce="(c) => c.tId"
                  name="title"
                  id="Title"
                  :disabled="!pflag"
                  ><span slot="no-options">No data</span></v-select
                >
                <span class="sa-val-err">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
        </div>
        <div v-if="pflag" class="sa-row">
          <div class="sa-col-xs6 sa-col-sm6 sa-col-md6 sa-col-lg4">
            <ValidationProvider
              name="first name in english"
              rules="required"
              v-slot="{ errors }"
              tag="div"
              class="sa-form-group"
            >
              <label>
                First Name
                <span class="sa-red-text">*</span>
              </label>
              <input
                v-model="personalInfoReq.personal.fn.en"
                type="text"
                name="first name in english"
                id="firstNameInEnglish"
                class="sa-form-control"
                :disabled="!pflag"
                :class="!pflag ? 'sa-disabled' : ''"
              />
              <span class="sa-val-err">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div class="sa-col-xs6 sa-col-sm6 sa-col-md6 sa-col-lg4">
            <ValidationProvider
              name="first name in arabic"
              rules="required"
              v-slot="{ errors }"
              tag="div"
              class="sa-form-group"
            >
              <label>
                First Name (Arabic)
                <span class="sa-red-text">*</span>
              </label>
              <input
                v-model="personalInfoReq.personal.fn.ar"
                type="text"
                class="sa-form-control"
                name="first name in arabic"
                id="firstNameInArabic"
                :disabled="!pflag"
                :class="!pflag ? 'sa-disabled' : ''"
              />
              <span class="sa-val-err">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
        </div>
        <div v-if="pflag" class="sa-row">
          <div class="sa-col-xs6 sa-col-sm6 sa-col-md6 sa-col-lg4">
            <ValidationProvider
              name="last name in english"
              rules="required"
              v-slot="{ errors }"
              tag="div"
              class="sa-form-group"
            >
              <label>
                Last Name
                <span class="sa-red-text">*</span>
              </label>
              <input
                v-model="personalInfoReq.personal.ln.en"
                name="last name in english"
                type="text"
                class="sa-form-control"
                id="lastNameInEnglish"
                :disabled="!pflag"
                :class="!pflag ? 'sa-disabled' : ''"
              />
              <span class="sa-val-err">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>

          <div class="sa-col-xs6 sa-col-sm6 sa-col-md6 sa-col-lg4">
            <ValidationProvider
              name="last name in arabic"
              rules="required"
              v-slot="{ errors }"
              tag="div"
              class="sa-form-group"
            >
              <label>
                Last Name (Arabic)
                <span class="sa-red-text">*</span>
              </label>
              <input
                v-model="personalInfoReq.personal.ln.ar"
                type="text"
                class="sa-form-control"
                name="last name in arabic"
                id="lastNameInArabic"
                :disabled="!pflag"
                :class="!pflag ? 'sa-disabled' : ''"
              />
              <span class="sa-val-err">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
        </div>
        <div class="sa-row">
          <div class="sa-col-xs12 sa-col-sm12 sa-col-md12 sa-col-lg4">
            <ValidationProvider
              rules="required"
              tag="div"
              class="sa-form-group"
              v-slot="{ errors }"
              name="gender"
            >
              <label>
                Gender
                <span class="sa-red-text">*</span>
              </label>
              <div v-if="pflag" class="sa-pro-radio custom-radio">
                <input
                  v-model="personalInfoReq.personal.gnd"
                  type="radio"
                  id="male"
                  name="gender"
                  value="M"
                />
                <label for="male">
                  <span class="sa-male sa-sprite sa-h-xs"></span> Male
                </label>
                <input
                  v-model="personalInfoReq.personal.gnd"
                  type="radio"
                  id="female"
                  name="gender"
                  value="F"
                />
                <label for="female">
                  <span class="sa-female sa-sprite sa-h-xs"></span> Female
                </label>
              </div>
              <div v-else class="sa-pro-radio">
                <span v-if="gender === 'M'">
                  <input
                    v-model="personalInfoReq.personal.gnd"
                    type="radio"
                    id="male"
                    name="gender"
                    value="M"
                  />
                  <label>
                    <span class="sa-male sa-sprite sa-h-xs"></span> Male
                  </label>
                </span>
                <span v-else>
                  <input
                    v-model="personalInfoReq.personal.gnd"
                    type="radio"
                    id="female"
                    name="gender"
                    value="F"
                  />
                  <label>
                    <span class="sa-female sa-sprite sa-h-xs"></span> Female
                  </label>
                </span>
              </div>
              <span class="sa-val-err">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <!-- <div v-if="pflag" class="sa-col-xs12 sa-col-sm6 sa-col-md4 sa-col-lg2">
            <ValidationProvider
              rules="required"
              tag="div"
              class="sa-form-group"
              v-slot="{errors}"
              name="Code"
            >
              <label>
                Code
                <span class="sa-red-text">*</span>
              </label>
              <v-select
                :options="mobileCodes"
                v-model="personalInfoReq.personal.pc"
                label="nameCode"
                :reduce="c => (c.countryAreaCode).toString()"
                :disabled="!pflag"
                :class="!pflag?'sa-disabled':''"
              ><span slot="no-options">No data</span>
              <template slot="selected-option" slot-scope="option">
                +{{option.countryAreaCode}}
              </template></v-select>
              <span class="sa-val-err">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div v-if="!pflag" class="sa-col-xs12 sa-col-sm6 sa-col-md4 sa-col-lg5">
            <div class="sa-form-group">
              <label>
                Mobile Number
                <span class="sa-red-text">*</span>
              </label>
              <input
                v-model="personalInfoReq.personal.mob"
                type="text"
                class="sa-form-control"
                :disabled="!pflag"
                :class="!pflag?'sa-disabled':''"
              />
            </div>
          </div>
          <div v-if="pflag" class="sa-col-xs12 sa-col-sm6 sa-col-md4 sa-col-lg5">
            <ValidationProvider
              rules="required"
              tag="div"
              class="sa-form-group"
              v-slot="{errors}"
              name="Mobile Number"
            >
              <label>
                Mobile Number
                <span class="sa-red-text">*</span>
              </label>
              <input
                v-model="personalInfoReq.personal.ph"
                type="number"
                class="sa-form-control"
                :disabled="!pflag"
                :class="!pflag?'sa-disabled':''"
              />
              <span class="sa-val-err">{{ errors[0] }}</span>
            </ValidationProvider>
          </div> -->
          <div class="sa-col-xs12 sa-col-sm6 sa-col-md6 sa-col-lg4">
            <div class="sa-form-group">
              <div class="sa-form-group">
                <label> Nationality </label>
                <v-select
                  :options="nationalityList"
                  v-model="personalInfoReq.personal.natio"
                  label="countryName"
                  :reduce="(c) => c.countryId.toString()"
                  name="nationality"
                  id="nationality"
                  :disabled="!pflag"
                  ><span slot="no-options">No data</span></v-select
                >
              </div>
            </div>
          </div>
          <div
            v-if="pflag"
            class="sa-col-xs12 sa-col-sm6 sa-col-md6 sa-col-lg4 sa-ellipsis"
          >
            <ValidationProvider
              name="email"
              rules="required"
              v-slot="{ errors }"
              tag="div"
              class="sa-form-group"
            >
              <label>
                Email
                <span class="sa-red-text">*</span>
              </label>
              <input
                v-model="personalInfoReq.personal.email"
                name="email"
                id="email"
                disabled
                type="text"
                class="sa-form-control"
                :class="!pflag ? 'sa-disabled' : ''"
              />
              <span class="sa-val-err">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
        </div>
        <div class="sa-row">
          <!-- <div class="sa-col-xs12 sa-col-sm6 sa-col-md4 sa-col-lg4">
            <ValidationProvider
              name="Date of Birth"
              rules="required"
              v-slot="{ errors }"
              tag="div"
              class="sa-form-group"
            >
              <label>DOB</label>
              <i class="icon-picker sa-form-icon sa-f-size16 "></i>
                <vc-date-picker :max-date="new Date()" v-model="personalInfoReq.personal.dob" class="sa-edit-date"> 
                <input
                  id="date"
                  readonly
                  class="sa-form-control"
                  slot-scope="{ inputProps, inputEvents, isDragging }"
                  :class="[`${!pflag?'sa-disabled':''}  ${isDragging ? '' : '' }`, { '': 'errorMessage' }]"
                  :disabled="!pflag"
                  v-bind="inputProps"
                />
              </vc-date-picker>
            <span class="sa-val-err">{{ errors[0] }}</span>
            </ValidationProvider>
          </div> -->
          <!-- <div class="sa-col-xs12 sa-col-sm6 sa-col-md4 sa-col-lg4">
            <div class="sa-form-group">
              <label>Blood Group</label>
              <v-select
                :options="bloodgroups"
                v-model="personalInfoReq.personal.blood"
                :disabled="!pflag"
              ><span slot="no-options">No data</span></v-select>
            </div>
          </div> -->
          <div
            v-if="
              personalInfoReq.personal.utid == '1' ||
              personalInfoReq.personal.utid == '2'
            "
            class="sa-col-xs12 sa-col-sm12 sa-col-md12 sa-col-lg12"
          >
            <div class="sa-form-group">
              <label>Short Biography</label>
              <textarea
                v-model="personalInfoReq.personal.bio.en"
                class="sa-form-control"
                :disabled="!pflag"
                :class="!pflag ? 'sa-disabled' : ''"
                id="shortBiography"
                name="short Biography"
              />
            </div>
          </div>
          <div
            v-if="
              pflag &&
              (personalInfoReq.personal.utid == '1' ||
                personalInfoReq.personal.utid == '2')
            "
            class="sa-col-xs12 sa-col-sm12 sa-col-md12 sa-col-lg12"
          >
            <div class="sa-form-group">
              <label>Short Biography(Arabic)</label>
              <textarea
                v-model="personalInfoReq.personal.bio.ar"
                class="sa-form-control"
                :disabled="!pflag"
                :class="!pflag ? 'sa-disabled' : ''"
                name="Short Biography(Arabic)"
                id="shortBioArabic"
              />
            </div>
          </div>
          <div
            v-if="
              personalInfoReq.personal.utid == '1' ||
              personalInfoReq.personal.utid == '2'
            "
            class="sa-col-xs12 sa-col-sm6 sa-col-md6 sa-col-lg4"
          >
            <div class="sa-form-group">
              <label>Attached Bio</label>
              <file-upload-multiple
                :pflag="pflag"
                :fileData="personalInfoReq.personal.bio_att"
                v-on:file-upload-success="setImg($event, 'bio')"
              />
            </div>
          </div>
          <div
            v-if="
              personalInfoReq.personal.utid == '1' ||
              personalInfoReq.personal.utid == '2' ||
              personalInfoReq.personal.utid == '3'
            "
            class="sa-col-xs12 sa-col-sm6 sa-col-md6 sa-col-lg4"
          >
            <ValidationProvider
              rules="required"
              tag="div"
              class="sa-form-group"
              v-slot="{ errors }"
              name="Medical Reg. number"
            >
              <label>
                Medical license number
                <span class="sa-red-text">*</span>
              </label>
              <input
                v-model="personalInfoReq.personal.med_reg"
                type="text"
                class="sa-form-control"
                :class="!pflag ? 'sa-disabled' : ''"
                id="medicalLicenseNumber"
                name="Medical Reg number"
              />
              <span class="sa-val-err">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div
            v-if="
              personalInfoReq.personal.utid == '1' ||
              personalInfoReq.personal.utid == '2' ||
              personalInfoReq.personal.utid == '3'
            "
            class="sa-col-xs12 sa-col-sm6 sa-col-md12 sa-col-lg4"
          >
            <ValidationProvider
              name="Date of Birth"
              rules="required"
              v-slot="{ errors }"
              tag="div"
              class="sa-form-group"
            >
              <label
                >Medical license expiry date
                <span class="sa-red-text">*</span></label
              >
              <i class="icon-picker sa-form-icon sa-f-size16"></i>
              <vc-date-picker
                v-model="personalInfoReq.personal.med_reg_exp"
                :min-date="new Date()"
                :popover="{
                  placement: $screens({ default: 'bottom-end' }),
                  visibility: 'click',
                }"
                class="sa-edit-date"
                :masks="masks"
              >
                <input
                  id="date"
                  name="date"
                  readonly
                  class="sa-form-control"
                  slot-scope="{ inputProps, inputEvents, isDragging }"
                  :class="[
                    `${!pflag ? 'sa-disabled' : ''}  ${isDragging ? '' : ''}`,
                    { '': 'errorMessage' },
                  ]"
                  :disabled="!pflag"
                  v-bind="inputProps"
                />
              </vc-date-picker>
              <span class="sa-val-err">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
        </div>
        <div v-if="personalInfoReq.personal.utid == '1'" class="sa-row">
          <div class="sa-col-xs12 sa-col-sm6 sa-col-md6 sa-col-lg4">
            <div class="sa-form-group">
              <label>Residency</label>
              <v-select
                taggable
                multiple
                v-model="personalInfoReq.personal.res"
                class="sa-multiple-tag"
                :disabled="!pflag"
                :class="!pflag ? 'sa-disabled' : ''"
                id="residency"
                name="Residency"
                ><span slot="no-options">No data</span></v-select
              >
              <!-- <v-select :options="selectfelloship" v-model="pInfo.felship" :disabled="!pflag" :class="!pflag?'sa-disabled':''"></v-select> -->
            </div>
          </div>
          <div
            v-if="pflag"
            class="sa-col-xs12 sa-col-sm6 sa-col-md6 sa-col-lg4"
          >
            <div class="sa-form-group">
              <label>Residency ( Arabic )</label>
              <v-select
                taggable
                v-model="personalInfoReq.personal.res_ar"
                multiple
                class="sa-multiple-tag"
                :disabled="!pflag"
                :class="!pflag ? 'sa-disabled' : ''"
                name="Residency (Arabic)"
                id="residencyArabic"
                ><span slot="no-options">No data</span></v-select
              >
              <!-- <v-select :options="selectfelloship" v-model="pInfo.felship" :disabled="!pflag" :class="!pflag?'sa-disabled':''"></v-select> -->
            </div>
          </div>
        </div>
        <!-- <div class="sa-col-xs12 sa-col-sm12 sa-col-md12 sa-col-lg12">
            <div class="sa-form-group">
              <label>Status</label>
               <span :disabled="!pflag" :class="!pflag?'sa-disabled sa-d-none ':'sa-p-checkbox '">
                <input type="checkbox" id="checkbox" v-model="personalInfoReq.personal.active" />
                <label for="checkbox">Active</label>
              </span>
              <span
                v-if="personalInfoReq.personal.active"
                :disabled="!pflag"
                :class="!pflag?'':'sa-d-none'"
              >
                <span class="sa-status-active sa-mr10"></span>
                <span class="sa-green-text">Active</span>
              </span>
              
              <span
                v-if="!personalInfoReq.personal.active"
                :disabled="!pflag"
                :class="!pflag?'':'sa-d-none'"
              >
                 <span class="sa-status-inactive sa-mr10"></span>
                 <span class="sa-red-text">In Active</span>
              </span>
            </div>
          </div> -->
        <div v-if="pflag" class="sa-text-right">
          <button
            class="sa-btn sa-btn-primary sa-btn-block-xs"
            @click.prevent="handleSubmit(updateProfile)"
          >
            Save
          </button>
        </div>
      </form>
      <div class="sa-dialog-white" v-if="loader">
        <img src="../../assets/img/loader.svg" alt="loader" class="sa-loader" />
      </div>
    </ValidationObserver>
  </div>
</template>
<script>
import AvtarVue from "../common/Avtar.vue";
import { pro_url } from "../../../config/endpoints";

import { oh_url, com_url } from "../../../config/endpoints";
import { extend } from "vee-validate";
import moment from "moment";
import {
  required,
  numeric,
  email,
  alpha_spaces,
  regex,
} from "vee-validate/dist/rules";
import FileUploadMultipleVue from "../common/FileUploadMultiple.vue";
export default {
  props: ["pInfo"],
  components: {
    avtar: AvtarVue,
    "file-upload-multiple": FileUploadMultipleVue,
  },
  data() {
    return {
      masks: {
        input: "DD-MMM-YYYY",
      },
      profilePerc: 50,
      bloodgroups: ["A+", "B+", "AB+", "A-", "B-", "AB-", "O+", "O-"],
      mobileCodes: null,
      date: new Date(),
      checked: true,
      editBoolean: false,
      loader: false,
      pflag: false,
      imgUrl: null,
      gender: "M",
      img: "",
      imgName: "",
      nameTitles: [],
      nationalityList: [],
      degreeList: [],
      langList: ["Arabic", "English"],
      userInfo: {},
      personalInfoReq: {
        mtype: "personal",
        personal: {
          img:
            "https://img.litedev.com/mis/7efcba2dfbe6625330d8c4ae02934397.jpg",
          title_id: "",
          fn: {
            en: "",
            ar: "",
          },
          gnd: "",
          ln: {
            en: "",
            ar: "",
          },
          pc: "",
          ph: "",
          email: "",
          blood: "",
          dob: "",
          bio: {
            en: "",
            ar: "",
          },
          natio: "",
          bio_att: [],
          med_reg: "",
          med_reg_exp: "",
          res: [],
          res_ar: [],
        },
      },
    };
  },
  watch: {
    pflag: {
      immediate: true,
      deep: true,
      handler() {
        let _self = this;
        _self.editBoolean = _self.pflag;
      },
    },
    pInfo: {
      immediate: true,
      handler() {
        let _self = this;
        if (_self.pInfo) {
          _self.gender = _self.pInfo.personal.gnd;
        }
      },
    },
  },
  methods: {
    setImg(uimg) {
      let _self = this;
      _self.img = uimg;
      _self.imgName = uimg.filename;
      _self.icon_bio = uimg.filename.split(".")[1] || null;
      _self.personalInfoReq.personal.bio_att.push({
        name: uimg.filename,
        url: uimg.url,
      });
    },
    setProfileData() {
      let _self = this;
      // _self.personalInfoReq['fn'] = _self.pInfo.fn
      // _self.personalInfoReq['ln'] = _self.pInfo.ln
      // _self.personalInfoReq['gnd'] = _self.pInfo.gnd
      // _self.personalInfoReq['title_id'] = _self.pInfo.title_id
      // _self.personalInfoReq['natio'] = _self.pInfo.natio
      // _self.personalInfoReq['deg'] = _self.pInfo.deg
      // _self.personalInfoReq['known_lang'] = _self.pInfo.known_lang
      // _self.personalInfoReq['img'] = _self.pInfo.img || 'https://img.litedev.com/mis/7efcba2dfbe6625330d8c4ae02934397.jpg'
      _self.personalInfoReq.personal = _self.pInfo.personal;
      _self.personalInfoReq.personal.mob =
        (_self.personalInfoReq.personal.pc || "") +
        " " +
        (_self.personalInfoReq.personal.ph || "");
      if (_self.personalInfoReq.personal.dob) {
        _self.personalInfoReq.personal.dob = new Date(
          moment(_self.personalInfoReq.personal.dob, "DD-MM-YYYY").format(
            "YYYY MM DD"
          )
        );
      }
      if (_self.personalInfoReq.personal.med_reg_exp) {
        _self.personalInfoReq.personal.med_reg_exp = new Date(
          moment(
            _self.personalInfoReq.personal.med_reg_exp,
            "YYYY-MM-DD"
          ).format("DD-MMM-YYYY")
        );
      }
    },
    // get static data
    getStaticData() {
      let _self = this;
      _self.$store
        .dispatch("httpPost", {
          uri: `${oh_url}/general/getStaticData`,
          body: {
            mtype: ["nat", "nameTitles", "code", "deg", "classifications"],
            utid: _self.userInfo.utid,
          },
        })
        .then((response) => {
          if ((response.status === 1000)) {
            _self.nameTitles = response.data.nameTitles;
            _self.nationalityList = response.data.country;
            _self.degreeList = response.data.degree;
            _self.mobileCodes = response.data.code;
            if (_self.mobileCodes && _self.mobileCodes.length) {
              _self.mobileCodes.map((pc) => {
                pc.nameCode = pc.countryName + "+" + pc.countryAreaCode;
              });
            }
          }
        })
        .catch((e) => {
          // console.log(e);
        });
    },
    updateProfile(obj, params) {
      let _self = this;
      _self.loader = true;
      if (_self.imgUrl) {
        _self.personalInfoReq.personal.img = _self.imgUrl;
        _self.userInfo.img = _self.imgUrl;
        _self.$localStorage.set(
          "userdata",
          JSON.stringify(_self.userInfo),
          60 * 60 * 2 + 55
        );
      }
      if (_self.personalInfoReq.personal.dob) {
        _self.personalInfoReq.personal.dob = moment(
          _self.personalInfoReq.personal.dob
        ).format("YYYY-MM-DD");
      }
      if (_self.personalInfoReq.personal.med_reg_exp) {
        _self.personalInfoReq.personal.med_reg_exp = moment(
          _self.personalInfoReq.personal.med_reg_exp
        ).format("YYYY-MM-DD");
      }
      delete _self.personalInfoReq.personal.utid;
      delete _self.personalInfoReq.personal.uid;
      delete _self.personalInfoReq.personal.mob;
      delete _self.personalInfoReq.personal.title_nm;
      delete _self.personalInfoReq.personal.name;
      delete _self.personalInfoReq.personal.status;
      delete _self.personalInfoReq.personal.profile_complete;
      _self.$store
        .dispatch("httpPost", {
          uri: `${pro_url}/addProfile`,
          body: _self.personalInfoReq,
        })
        .then((response) => {
          if (_self.personalInfoReq.personal.dob) {
            _self.personalInfoReq.personal.dob = new Date(
              moment(_self.personalInfoReq.personal.dob, "DD-MM-YYYY").format(
                "YYYY MM DD"
              )
            );
          }
          if (_self.personalInfoReq.personal.med_reg_exp) {
            _self.personalInfoReq.personal.med_reg_exp = new Date(
              moment(
                _self.personalInfoReq.personal.med_reg_exp,
                "YYYY-MM-DD"
              ).format("DD-MMM-YYYY")
            );
          }
          if (response && response.status === 1000) {
            _self.$parent.getUserData();
            _self.$store.dispatch("SET_ALERTMESSAGE", {
              msg: "Personal information updated successfully",
              class: "sa-a-success",
            });
          } else if (response && response.status == "2001") {
            _self.$store.dispatch("SET_ALERTMESSAGE", {
              msg: "Session Expired. Please login again",
              class: "sa-a-danger",
            });
            _self.$localStorage.remove("token");
            _self.$localStorage.remove("userdata");
            _self.$router.push({ path: "/" });
          } else {
            _self.$store.dispatch("SET_ALERTMESSAGE", {
              msg: "Something went wrong",
              class: "sa-a-danger",
            });
          }
          _self.loader = false;
        })
        .catch((e) => {
          _self.$store.dispatch("SET_ALERTMESSAGE", {
            msg: "Something went wrong",
            class: "sa-a-danger",
          });
          _self.loader = false;
        });
    },
  },

  created() {
    this.userInfo = JSON.parse(this.$localStorage.get("userdata")) || {};
    this.getStaticData();
    this.setProfileData();
  },
  computed: {
    errorMessage() {
      if (!this.date) return "Date is required.";
      return "";
    },
  },
};
</script>
